import { Reducer } from 'redux';
import { PreCasInterviewState, PreCasInterviewTypes } from './types';
import { StudentActionTypes, Q } from '../types';
import { hasPerm, P } from '../../../utilities/roles/permissions';
import { UserRole } from '../../auth/types';

const initialState: PreCasInterviewState = {
  whyUk: '',
  whyUkOther: '',
  selectedCourseReasons: [],
  selectedCourseReasonsOther: '',
  selectedUniReasons: [],
  selectedUniReasonsOther: '',
  uniChoiceReason1: '',
  uniChoiceReason2: '',
  uniChoiceReason3: '',
  campus: '',
  considerOtherUni: true,
  otherUni1: '',
  otherUni2: '',
  selectedResearchMethods: [],
  selectedResearchMethodsOther: '',
  whyNotOtherUni: '',
  considerOtherCourses: undefined,
  considerOtherCourse: '',
  whyNotConsiderOtherCourse: '',
  courseAlignFutureCareer: undefined,
  courseAlignFutureCareerOther: '',
  workWhileStudy: undefined,
  maxWorkHoursPerWeek: '',
  whyWorkWhileStudy: '',
  whyWorkWhileStudyOther: '',
  affordCourseAndLivingWithoutWorking: undefined,
  affordCourseAndLivingWithoutWorkingNo: '',
  completeDegreeWorkCountry: '',
  expectedSalary: 0,
  furtherStudyInUk: undefined,
  furtherStudyCareerPlans: '',
  liveWhileStudying: '',
  liveWhileStudyingOther: '',
  expectedWeeklyRent: 0,
  commutePlan: '',
  expectedLivingExpenses: 0,
  awareOfUKVIInterview: undefined,
  isSectionStarted: false,
  isSectionComplete: false,
};

const reducer: Reducer<PreCasInterviewState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...initialState,
        ...action.payload.student.preCasInterview,
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS:
      if (action.payload.preCasInterview) {
        return {
          ...state,
          ...action.payload.preCasInterview,
        };
      }
      return state;
    case PreCasInterviewTypes.UPDATE_PCI_FIELD:
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value,
      };
    default:
      return state;
  }
};

export const preCasFlags = (state: PreCasInterviewState, role: UserRole): number => {
  let flags = 0;
  if (!hasPerm(role, P.PRE_CAS_INTERVIEW_FLAGS)) return flags;
  if (state[Q.CONSIDER_OTHER_UNI] === false) flags++;
  if (state[Q.WHY_WORK_WHILE_STUDY] === 'Other') flags++;
  if (state[Q.COMPLETE_DEGREE_WORK_COUNTRY] === 'United Kingdom') flags++;
  if (state[Q.AFFORD_COURSE_AND_LIVING_WITHOUT_WORKING] === false) flags++;
  return flags;
};

export { reducer as preCasInterviewReducer };
